// MotorCommercialStore.js - Vuex module for Motor Commercial Insurance
import motorCommercialService from './motorCommercialService';

const motorCommercialModule = {
	namespaced: true,
	state: () => ({
		currentStep: 1,
		vehicleType: null,
		vehicleValue: 0,
		tonnageCapacity: null,
		coverType: null,
		usageDetails: {
			primaryUse: null,
			goodsCarried: null,
			routes: null,
		},
		quotedProducts: [],
		selectedProduct: null,
		vehicleDetails: {},
		kycDetails: {},
		paymentStatus: 'pending', // 'pending', 'success', 'failed'
	}),
	mutations: {
		SET_CURRENT_STEP(state, step) {
			state.currentStep = step;
		},
		SET_VEHICLE_TYPE(state, type) {
			state.vehicleType = type;
		},
		SET_VEHICLE_VALUE(state, value) {
			state.vehicleValue = value;
		},
		SET_TONNAGE_CAPACITY(state, capacity) {
			state.tonnageCapacity = capacity;
		},
		SET_COVER_TYPE(state, type) {
			state.coverType = type;
		},
		SET_USAGE_DETAILS(state, details) {
			state.usageDetails = { ...details };
		},
		SET_QUOTED_PRODUCTS(state, products) {
			state.quotedProducts = products;
		},
		SET_SELECTED_PRODUCT(state, product) {
			state.selectedProduct = product;
		},
		SET_VEHICLE_DETAILS(state, details) {
			state.vehicleDetails = { ...details };
		},
		SET_KYC_DETAILS(state, details) {
			state.kycDetails = { ...details };
		},
		SET_PAYMENT_STATUS(state, status) {
			state.paymentStatus = status;
		},
		RESET_FLOW(state) {
			state.currentStep = 1;
			state.vehicleType = null;
			state.vehicleValue = 0;
			state.tonnageCapacity = null;
			state.coverType = null;
			state.usageDetails = {
				primaryUse: null,
				goodsCarried: null,
				routes: null,
			};
			state.quotedProducts = [];
			state.selectedProduct = null;
			state.vehicleDetails = {};
			state.kycDetails = {};
			state.paymentStatus = 'pending';
		},
	},
	actions: {
		nextStep({ commit, state }) {
			if (state.currentStep < 8) {
				commit('SET_CURRENT_STEP', state.currentStep + 1);
			}
		},
		previousStep({ commit, state }) {
			if (state.currentStep > 1) {
				commit('SET_CURRENT_STEP', state.currentStep - 1);
			}
		},
		setVehicleType({ commit }, type) {
			commit('SET_VEHICLE_TYPE', type);
		},
		setVehicleValue({ commit }, value) {
			commit('SET_VEHICLE_VALUE', value);
		},
		setTonnageCapacity({ commit }, capacity) {
			commit('SET_TONNAGE_CAPACITY', capacity);
		},
		setCoverType({ commit }, type) {
			commit('SET_COVER_TYPE', type);
		},
		setUsageDetails({ commit }, details) {
			commit('SET_USAGE_DETAILS', details);
		},
		setSelectedProduct({ commit }, product) {
			commit('SET_SELECTED_PRODUCT', product);
		},
		setVehicleDetails({ commit }, details) {
			commit('SET_VEHICLE_DETAILS', details);
		},
		setKYCDetails({ commit }, details) {
			commit('SET_KYC_DETAILS', details);
		},
		setPaymentStatus({ commit }, status) {
			commit('SET_PAYMENT_STATUS', status);
		},
		async fetchQuotations({ commit, state }) {
			if (state.vehicleType && state.coverType) {
				try {
					const products =
						await motorCommercialService.getCommercialQuotations(
							state.vehicleType,
							state.coverType,
						);
					commit('SET_QUOTED_PRODUCTS', products);
					commit('SET_SELECTED_PRODUCT', null); // Reset selection
				} catch (error) {
					console.error(
						'Failed to fetch commercial quotations:',
						error,
					);
					commit('SET_QUOTED_PRODUCTS', []);
				}
			}
		},
		resetFlow({ commit }) {
			commit('RESET_FLOW');
		},
	},
	getters: {
		// Optional getters
	},
};

export default motorCommercialModule;
